import {merge} from 'lodash';

import {
  COLLEGES,
  COLLEGE_ID,
  DEPARTMENTS, DEPARTMENT_ID,
  IDENTIFY_USER_EXIST_ON_DEVICE_FAIL,
  IDENTIFY_USER_EXIST_ON_DEVICE_START,
  IDENTIFY_USER_EXIST_ON_DEVICE_SUCCESSFUL,
  LOGIN_FAILURE,
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  RESET_STATE,
} from '../actionConstants';

import {createReducer} from './reducerUtils';

const initialState = {
  user: {
    email: '',
    password: '',
    role: '',
    id:'',  
    collegeId:'',
    departmentId:'',
  },
  login: {
    email: '',
    error: {message: '', error: '', errorCode: ''},
  },
  tokenData: '',
  loggedIn: false,
  allColleges:[],
  departments:[],
};

const updateCollegeId = (state = initialState, payload) => {
  return merge({}, state, {
    user: {collegeId: payload?.collegeId},
  });
};

const updateDeptId = (state = initialState, payload) => {
  return merge({}, state, {
    user: {departmentId: payload?.departmentId},
  });
};

const collegeData = (state = initialState, payload) => {
  return merge({}, state, {
    allColleges:payload?.colleges,
  });
};

const alldepartmentData = (state = initialState, payload) => {
  return merge({}, state, {
    departments:payload?.departments,
  });
};

const loginStart = (state = initialState, payload) => {
  return merge({}, state, {
    login: {error: {message: '', errorCode: '', error:''}, email: payload.email},
    user: {email: payload.email, password: payload.password}});
};

const loginSuccess = (state = initialState, payload) => {
  return merge({}, state, {
    loggedIn: true,
    tokenData: payload.token,
    login: {error: {message: '', errorCode: '', error:''}, email: payload.email},
    user: {email: payload.email, password: payload.password, role:payload.role, id:payload.id},
  });
};

const loginFailure = (state = initialState, payload) => {
  return merge({}, state, {
    loggedIn: false,
    login: {error: {message:payload?.message, errorCode: '', error:payload?.error}, email: ''},
  });
};

const logoutSuccess = (state = initialState) => {
  return initialState;
};

const identifyUserExistOnDeviceStart = state => ({
  ...state,
  loading: true,
});

const identifyUserExistOnDeviceSuccessful = (state, payload) => {
  return {
    ...state,
    loggedIn: true,
    loading: false,
    user: payload,
    tokenData: payload?.token,
  };
};

const identifyUserExistOnDeviceFail = state => ({
  ...state,
  loggedIn: false,
  loading: false,
  user: null,
});

const resetAuthData = (state = initialState, payload) => {
  return initialState;
};

export default createReducer(initialState, {
  [LOGIN_START]: loginStart,
  [RESET_STATE]: resetAuthData,
  [LOGIN_SUCCESS]: loginSuccess,
  [LOGIN_FAILURE]: loginFailure,
  [LOGOUT_SUCCESS]: logoutSuccess,
  [IDENTIFY_USER_EXIST_ON_DEVICE_START]: identifyUserExistOnDeviceStart,
  [IDENTIFY_USER_EXIST_ON_DEVICE_SUCCESSFUL]: identifyUserExistOnDeviceSuccessful,
  [IDENTIFY_USER_EXIST_ON_DEVICE_FAIL]: identifyUserExistOnDeviceFail,
  [COLLEGE_ID] : updateCollegeId,
  [DEPARTMENT_ID]:updateDeptId,
  [COLLEGES]:collegeData,
  [DEPARTMENTS]:alldepartmentData,
});
